import React from "react";
import { motion } from "framer-motion";

export default function PageHero({ title, subtitle, actions, badge }) {
  return (
    <motion.section
      className="erp-page-hero erp-card"
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: "easeOut" }}
    >
      <div className="erp-page-hero-copy">
        {badge ? <div className="erp-page-badge">{badge}</div> : null}
        <h1 className="erp-page-title">{title}</h1>
        <p className="erp-page-subtitle">{subtitle}</p>
      </div>
      <div className="erp-page-actions">{actions}</div>
    </motion.section>
  );
}
